import YearPage from "./YearPage";
export default YearPage;
